module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-sign-off-502a984548efd877aa169c157ac157ad.svg";